import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, ExternalLink, Sun, Zap, Flame } from "lucide-react";
import { SECTORS } from "../data/wizardConfig";
import { useAuth } from "../context/AuthContext";

export default function SectorSelect() {
    const { user } = useAuth();
    const allowed = user?.role === "admin" ? null : user?.allowed_sectors ?? null;

    return (
        <div className="max-w-7xl mx-auto" data-testid="sector-select-page">
            <div className="text-center mb-10">
                <div className="inline-flex items-center gap-2 bg-[#C7FF2C]/30 text-[#0C4650] px-3 py-1 rounded-full text-xs font-bold">
                    <Sparkles className="w-3 h-3" /> NUOVO PREVENTIVO
                </div>
                <h1 className="mt-4 text-4xl sm:text-5xl font-black text-[#0C4650]">
                    Scegli l'area di interesse
                </h1>
                <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
                    Percorsi guidati + strumenti intelligenti per costruire la proposta perfetta in pochi minuti.
                </p>
            </div>

            <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto">
                {Object.values(SECTORS)
                    .filter((s) => !allowed || allowed.includes(s.key))
                    .map((s, i) => (
                    <Link
                        key={s.key}
                        to={s.key === "energy_quoter" ? "/energy-quoter" : `/nuovo-preventivo/${s.key}`}
                        className="group relative overflow-hidden rounded-3xl border-2 border-transparent bg-white hover:border-[#C7FF2C] hover:-translate-y-1 transition-all shadow-sm hover:shadow-xl fade-up flex flex-col"
                        style={{ animationDelay: `${i * 0.08}s` }}
                        data-testid={`sector-card-${s.key}`}
                    >
                        <div
                            className="h-44 bg-cover bg-center"
                            style={{ backgroundImage: `url(${s.image})` }}
                        >
                            <div className="h-full bg-gradient-to-t from-[#0C4650] via-[#0C4650]/30 to-transparent" />
                        </div>
                        <div className="p-5 flex-1 flex flex-col">
                            <div className="text-[10px] tracking-[0.3em] text-[#898A8D] font-bold">
                                SETTORE 0{i + 1}
                            </div>
                            <h2 className="mt-1 text-xl font-black text-[#0C4650] leading-tight">
                                {s.label}
                            </h2>
                            <p className="mt-1 text-gray-600 text-sm flex-1">{s.tagline}</p>
                            <div className="mt-4 inline-flex items-center gap-1.5 text-[#0C4650] font-bold group-hover:gap-2.5 transition-all text-xs">
                                {s.key === "energy_quoter" ? "Analizza una bolletta" : "Avvia il wizard"}
                                <ArrowRight className="w-3.5 h-3.5" />
                            </div>
                        </div>
                    </Link>
                ))}

            </div>

            {allowed && allowed.length === 0 && (
                <div className="mt-8 card p-6 border-l-4 border-amber-400 bg-amber-50/50 max-w-xl mx-auto" data-testid="no-sectors-alert">
                    <div className="font-bold text-[#0C4650]">Nessun settore abilitato</div>
                    <p className="text-sm text-gray-600 mt-1">
                        Il tuo profilo non ha ancora settori attivi. Contatta l'amministratore per richiedere le abilitazioni.
                    </p>
                </div>
            )}

            <div className="mt-10 text-center">
                <Link
                    to="/offerte"
                    className="btn-outline"
                    data-testid="browse-offers-from-select"
                >
                    Parti da un'offerta del catalogo
                </Link>
            </div>
        </div>
    );
}
